/**
 * @author Martin Leonov <martin.leonov@ki-wi.cz>
 * @copyright Ki-Wi Digital s.r.o.
 * @license
 * All Rights Reserved.
 * Unauthorized copying of this file is strictly prohibited.
 * Proprietary and confidential.
 */

/**
 * Prázdné zdroje.
 * @implements {ViewerSource}
 */
class EmptyViewerSource {
  constructor(parentEl) {
    this.parentEl = parentEl;
  }

  destroy() {}

  getEl() {
    return null;
  }

  getFrame() {
    return null;
  }

  setParentEl(parentEl) {
    this.parentEl = parentEl;
  }
}

/**
 * Poskytovatel prázdných zdrojů pro zobrazování deterministických playlistů.
 * @implements {ViewerSourceCreator}
 */
class EmptyViewerSourceCreator {
  /**
   * Vytvoří instanci.
   */
  constructor() {
    this.source = new EmptyViewerSource();
  }

  /** @inheritdoc */
  delete(source) {
    return Promise.resolve();
  }

  /** @inheritdoc */
  destroy() {}

  /** @inheritdoc */
  getLent() {
    return 0;
  }

  /** @inheritdoc */
  getMax() {
    return 1;
  }

  /** @inheritdoc */
  lend(parentEl, scheduleInfo) {
    return new Promise((resolve) => {
      this.source.setParentEl(parentEl);
      return resolve(this.source);
    });
  }

  /** @inheritdoc */
  receive(source) {
    return Promise.resolve();
  }

  /** @inheritdoc */
  replace() {
    // Není třeba nic provést.
    return Promise.resolve();
  }
}

export default EmptyViewerSourceCreator;
